export default {
  header: "Radar",
  view: "Radar",
  weatherfact: [],
};
